// City content for /towing/:citySlug pages.
// Each city has genuinely unique local content: neighborhoods, highways,
// landmarks, and local FAQs. Do not fabricate — content sticks to real
// facts about each city and how BM Towing operates there.

export const CITIES = {
  kirkland: {
    slug: "kirkland",
    path: "/kirkland-towing",
    name: "Kirkland",
    fullName: "Kirkland, WA",
    metaTitle: "24/7 Tow Truck in Kirkland, WA | BM Towing & Recovery",
    metaDesc: "BM Towing & Recovery is based in Kirkland, WA. 24/7 towing, flatbed transport, jump starts, lockouts, and winch-outs across every Kirkland neighborhood. Call (425) 647-9585.",
    h1: "Tow Truck in Kirkland, WA",
    hero: "BM Towing provides fast 24/7 towing and roadside assistance throughout Kirkland — including Lake Washington Blvd, Juanita, Totem Lake, and Rose Hill.",
    intro: "BM Towing & Recovery has been serving Kirkland out of our local base for years. Because we live and work here, we know every shortcut through Juanita, every I-405 exit into downtown, and every tight garage in Totem Lake. When you call from a Kirkland address, we're usually the fastest option.",
    neighborhoods: [
      "Downtown Kirkland & Marina",
      "Juanita",
      "Totem Lake",
      "Rose Hill",
      "Bridle Trails",
      "Finn Hill",
      "Kingsgate",
      "Highlands",
    ],
    highways: ["I-405", "SR-520", "NE 85th St", "Lake Washington Blvd", "Juanita Dr"],
    landmarks: [
      "Google Kirkland campus",
      "Evergreen Health Medical Center",
      "Kirkland Urban / Google campus",
      "Marina Park & Kirkland waterfront",
      "Totem Lake Mall",
    ],
    localAngle: "We handle everything from residential jump starts in Bridle Trails to flatbed transports out of the Kirkland Google campus. Kirkland's mix of tight residential streets and busy commercial corridors is exactly what we've built our fleet for.",
    faqs: [
      { q: "Where are you based in Kirkland?", a: "BM Towing & Recovery operates out of Kirkland, WA. Because we're local, most Kirkland calls get the fastest possible dispatch." },
      { q: "Do you tow to and from the Kirkland Google campus?", a: "Yes — we handle commercial pickups, employee vehicles, and dealer transfers around the Google Kirkland offices regularly." },
      { q: "Can you help on Kirkland residential streets?", a: "Absolutely. Our trucks are sized for tight streets in Juanita, Bridle Trails, and Rose Hill." },
      { q: "How fast can you get to me in Kirkland?", a: "Response times depend on traffic and where you are, but Kirkland calls are usually our quickest because we're already here." },
    ],
  },

  bellevue: {
    slug: "bellevue",
    path: "/tow-truck-bellevue",
    name: "Bellevue",
    fullName: "Bellevue, WA",
    metaTitle: "24/7 Tow Truck in Bellevue, WA | BM Towing & Recovery",
    metaDesc: "Fast 24/7 tow truck service in Bellevue, WA. Flatbed for luxury vehicles, jump starts, lockouts, and accident recovery. Call BM Towing (425) 647-9585.",
    h1: "Tow Truck in Bellevue, WA",
    hero: "From Downtown Bellevue high-rises to residential Somerset — one call gets a truck moving.",
    intro: "Bellevue is a big part of what we do. Between Downtown, Factoria, Crossroads, and Somerset, we handle everything from luxury flatbed transports out of dealerships to late-night lockouts in condo parking garages. Our trucks are equipped for both tight urban garages and residential driveways.",
    neighborhoods: [
      "Downtown Bellevue",
      "Bellevue Square area",
      "Factoria",
      "Crossroads",
      "Somerset",
      "Eastgate",
      "Newport Hills",
      "Woodridge",
      "West Bellevue / Medina",
      "Enatai",
    ],
    highways: ["I-405", "I-90", "SR-520", "148th Ave", "Bellevue Way", "NE 8th St"],
    landmarks: [
      "The Bellevue Collection & Bellevue Square",
      "Overlake Medical Center",
      "Meydenbauer Center",
      "T-Mobile HQ",
      "Bellevue Downtown Park",
      "Factoria Mall",
    ],
    localAngle: "Bellevue's mix of luxury dealerships and dense residential means we spend a lot of time here. Flatbed transports for Porsche, Audi, and Mercedes dealerships, plus everyday roadside help in Factoria and Crossroads — we handle both.",
    faqs: [
      { q: "Do you tow luxury cars in Bellevue?", a: "Yes — we flatbed transport for Bellevue's Porsche, Mercedes, Audi, and BMW dealerships regularly. See our pricing page for luxury rates." },
      { q: "Can you access downtown Bellevue parking garages?", a: "Yes. Our trucks are sized to enter most commercial parking structures. Give us the clearance height on the phone and we'll bring the right truck." },
      { q: "How fast is a Bellevue dispatch?", a: "We're often only a few minutes away from Bellevue jobs. We'll give you an honest ETA when you call." },
      { q: "Do you handle Bellevue accident tows?", a: "Yes — including working with the police at the scene and coordinating with your insurance company." },
    ],
  },

  redmond: {
    slug: "redmond",
    path: "/tow-truck-redmond",
    name: "Redmond",
    fullName: "Redmond, WA",
    metaTitle: "24/7 Tow Truck in Redmond, WA | BM Towing & Recovery",
    metaDesc: "24/7 tow truck service in Redmond, WA. Serving Overlake, Education Hill, Downtown Redmond and the Microsoft campus. Call BM Towing (425) 647-9585.",
    h1: "Tow Truck in Redmond, WA",
    hero: "From the Microsoft campus to Marymoor Park — Redmond is a quick call away.",
    intro: "Redmond calls come from a mix of the Microsoft campus, Overlake medical corridor, and the busy Bel-Red road area. We handle commercial pickups at tech campuses, dealer transfers, and everyday residential roadside help across every Redmond neighborhood.",
    neighborhoods: [
      "Downtown Redmond",
      "Overlake",
      "Education Hill",
      "Grass Lawn",
      "Idylwood",
      "Bear Creek",
      "Sammamish Valley",
    ],
    highways: ["SR-520", "SR-202 (Redmond-Fall City)", "Avondale Way", "148th Ave", "Bel-Red Rd"],
    landmarks: [
      "Microsoft Redmond campus",
      "Nintendo of America",
      "Marymoor Park",
      "Redmond Town Center",
      "Overlake Christian Church",
      "Willows Run Golf Course",
    ],
    localAngle: "Redmond is a big employer town — Microsoft, Nintendo, plus the Overlake medical corridor. Between corporate campus pickups, dealer transfers off SR-520, and residential help on Education Hill, we spend a lot of time here.",
    faqs: [
      { q: "Do you tow at the Microsoft campus?", a: "Yes — we do commercial and employee vehicle tows around the Microsoft Redmond campus regularly." },
      { q: "Can you reach me at Marymoor Park?", a: "Yes. Marymoor and the SR-520 corridor is a common call for us." },
      { q: "Do you handle Overlake area accident tows?", a: "Yes — we work post-collision tows in the Overlake medical corridor and along SR-520." },
    ],
  },

  "mercer-island": {
    slug: "mercer-island",
    path: "/tow-truck-mercer-island",
    name: "Mercer Island",
    fullName: "Mercer Island, WA",
    metaTitle: "24/7 Tow Truck in Mercer Island, WA | BM Towing & Recovery",
    metaDesc: "24/7 tow truck service in Mercer Island, WA. Fast dispatch across the island, I-90 corridor, and East/West Mercer neighborhoods. Call BM Towing (425) 647-9585.",
    h1: "Tow Truck in Mercer Island, WA",
    hero: "Stuck on I-90, in a garage on the island, or on a hillside driveway — we know Mercer Island.",
    intro: "Mercer Island sits right between Seattle and Bellevue on I-90, and calls here often involve the freeway, tunnel, or one of the island's hillside residential streets. Because we're based nearby in Kirkland, we cover Mercer Island quickly and know the tricky spots.",
    neighborhoods: [
      "North End",
      "East Seattle",
      "First Hill",
      "Mercerwood",
      "Faben Point",
      "South End",
      "Groveland",
    ],
    highways: ["I-90", "East Mercer Way", "West Mercer Way", "Island Crest Way", "SE 40th"],
    landmarks: [
      "Mercer Island Town Center",
      "Luther Burbank Park",
      "Mercerdale Park",
      "Aubrey Davis Park",
      "Island Crest",
    ],
    localAngle: "The I-90 corridor across Mercer Island is a common breakdown spot, and the island's hilly residential streets need experienced tow operators who know the neighborhoods. We handle both freeway shoulder recoveries and residential lockouts, jump starts, and flatbed pickups.",
    faqs: [
      { q: "How fast can you reach Mercer Island?", a: "Mercer Island is one of our closer service areas from our Kirkland base. Response times are typically fast — we'll give you an honest ETA on the phone." },
      { q: "Do you tow on I-90 near Mercer Island?", a: "Yes. I-90 freeway breakdowns and shoulder recoveries around the Mercer Island exits are common calls for us." },
      { q: "Can you handle Mercer Island hillside driveways?", a: "Yes — our trucks are sized for tight residential streets and steep driveways found across the island." },
    ],
  },

  newcastle: {
    slug: "newcastle",
    path: "/tow-truck-newcastle",
    name: "Newcastle",
    fullName: "Newcastle, WA",
    metaTitle: "24/7 Tow Truck in Newcastle, WA | BM Towing & Recovery",
    metaDesc: "24/7 tow truck in Newcastle, WA. Serving Newcastle hills, Coal Creek, and the I-405/Coal Creek Pkwy corridor. Call BM Towing (425) 647-9585.",
    h1: "Tow Truck in Newcastle, WA",
    hero: "Newcastle's hills, Coal Creek traffic, and I-405 breakdowns — we're built for all of it.",
    intro: "Newcastle sits on the Cougar Mountain foothills between Bellevue and Renton, and calls here often involve steep residential streets or the Coal Creek Parkway / I-405 corridor. Our trucks handle hills, tight streets, and freeway shoulders — the mix Newcastle actually needs.",
    neighborhoods: [
      "Downtown Newcastle",
      "Newcastle Hills",
      "Olympus",
      "Highlands",
      "May Creek",
      "Lake Boren area",
    ],
    highways: ["I-405", "Coal Creek Parkway", "Newcastle Way", "SE May Valley Rd"],
    landmarks: [
      "The Golf Club at Newcastle",
      "Lake Boren Park",
      "Cougar Mountain Regional Park",
      "Newcastle Commons",
      "Newport Hills border area",
    ],
    localAngle: "Newcastle's mix of steep residential terrain and the busy Coal Creek Parkway means we get a variety of calls here — flat tires on hillside streets, jump starts in Newcastle Commons lots, and breakdowns on I-405 near the Newcastle exits.",
    faqs: [
      { q: "Do you cover the Newcastle hills?", a: "Yes — our trucks are sized for tight, steep residential streets across Newcastle Hills, Olympus and Highlands." },
      { q: "Can you help on Coal Creek Parkway?", a: "Yes. Coal Creek Parkway and the nearby I-405 exits are frequent call areas for us." },
      { q: "Do you tow near The Golf Club at Newcastle?", a: "Yes — from the club and surrounding neighborhoods. Call anytime." },
    ],
  },

  sammamish: {
    slug: "sammamish",
    path: "/tow-truck-sammamish",
    name: "Sammamish",
    fullName: "Sammamish, WA",
    metaTitle: "24/7 Tow Truck in Sammamish, WA | BM Towing & Recovery",
    metaDesc: "24/7 tow truck in Sammamish, WA. Serving the Plateau, Klahanie, Trossachs, Pine Lake and Sammamish Highlands. Call BM Towing (425) 647-9585.",
    h1: "Tow Truck in Sammamish, WA",
    hero: "The Sammamish Plateau is spread out — that's why we cover it with the right trucks and honest ETAs.",
    intro: "Sammamish is a big, hilly, spread-out plateau community with a mix of large residential neighborhoods and connecting roads like Sahalee Way, 228th Ave, and Issaquah-Fall City Rd. We know the routes and cover Sammamish for everything from tire changes to full-length flatbed transports.",
    neighborhoods: [
      "Sammamish Plateau",
      "Pine Lake",
      "Klahanie",
      "Trossachs",
      "Sahalee",
      "Beaver Lake",
      "Inglewood",
    ],
    highways: ["228th Ave SE", "Sahalee Way", "Issaquah-Fall City Rd", "SE 8th St", "212th Way SE"],
    landmarks: [
      "Sahalee Country Club",
      "Beaver Lake Park",
      "Pine Lake Park",
      "Sammamish Commons",
      "Klahanie Park",
    ],
    localAngle: "Sammamish's spread-out geography means dispatch times can vary — we always give you an honest ETA on the phone. Common calls: winter no-starts on the plateau, tire changes on Sahalee Way, dead batteries in Klahanie garages, and dealer flatbed transports off 228th.",
    faqs: [
      { q: "Do you cover the whole Sammamish Plateau?", a: "Yes — from Klahanie through Pine Lake to Trossachs and Sahalee. Give us the address and we'll give you an honest ETA." },
      { q: "Can you help in winter weather on the Plateau?", a: "Yes. Sammamish gets icy on the hills — we handle winter recoveries and no-starts routinely." },
      { q: "How far is Sammamish from your base?", a: "We're based in Kirkland, so Sammamish dispatch is a moderate drive. We're honest about the ETA — no ghosting or vague promises." },
    ],
  },

  issaquah: {
    slug: "issaquah",
    path: "/tow-truck-issaquah",
    name: "Issaquah",
    fullName: "Issaquah, WA",
    metaTitle: "24/7 Tow Truck in Issaquah, WA | BM Towing & Recovery",
    metaDesc: "24/7 tow truck in Issaquah, WA. Serving I-90 corridor, downtown Issaquah, Issaquah Highlands, and Sammamish. Call BM Towing (425) 647-9585.",
    h1: "Tow Truck in Issaquah, WA",
    hero: "I-90 mountain traffic, Issaquah Highlands hills, downtown Issaquah — we cover it all.",
    intro: "Issaquah sits right on I-90 heading into the mountains, which means we get a lot of weather-related and long-trip calls here. From downtown Issaquah lockouts to Issaquah Highlands residential help to shoulder recoveries on I-90 — we're set up for it.",
    neighborhoods: [
      "Downtown Issaquah",
      "Issaquah Highlands",
      "Squak Mountain area",
      "Talus",
      "Newport / Klahanie",
      "Providence Point",
      "Cougar Mountain area",
    ],
    highways: ["I-90", "Front St / Sunset Way", "Issaquah-Hobart Rd", "Newport Way", "SE 56th"],
    landmarks: [
      "Costco HQ",
      "Issaquah Highlands village",
      "Cougar Mountain Zoo",
      "Lake Sammamish State Park",
      "Downtown Issaquah historic center",
      "Grand Ridge",
    ],
    localAngle: "Issaquah's mix of I-90 freeway traffic, hillside neighborhoods, and mountain-adjacent roads makes it one of our more variety-rich service areas. We handle winter weather recoveries, freeway breakdowns, and residential help all across Issaquah.",
    faqs: [
      { q: "Do you cover the I-90 corridor?", a: "Yes — I-90 shoulder recoveries, breakdowns near Issaquah exits, and long-distance tows are common calls for us." },
      { q: "Can you help in Issaquah Highlands?", a: "Yes. Issaquah Highlands' steep hills and residential neighborhoods are all within our regular service area." },
      { q: "Do you handle winter weather recoveries?", a: "Yes — Issaquah and Cougar Mountain get slick in winter. We're equipped for ice and snow recoveries." },
    ],
  },
  bothell: {
    slug: "bothell",
    path: "/tow-truck-bothell",
    name: "Bothell",
    fullName: "Bothell, WA",
    metaTitle: "24/7 Tow Truck in Bothell, WA | BM Towing & Recovery",
    metaDesc: "Stranded in Bothell? BM Towing dispatches a mobile tow truck fast across Canyon Park, Downtown Bothell, and the UW Bothell corridor. 24/7 roadside assistance. Call (425) 647-9585.",
    h1: "Bothell Tow Truck & Roadside Assistance — 24/7",
    hero: "Broken down on Bothell-Everett Highway? Locked out at Canyon Park? Our mobile trucks are already on the move.",
    intro: "Bothell sits at the intersection of King and Snohomish counties, and we treat it that way — dispatching from our Kirkland base with equipment ready for both freeway calls on I-405 and residential help off SR-522. Because we operate as a mobile service (no shop, no yard, no wait), one phone call puts a driver on your route within minutes, not hours. Community-focused help for commuters, families, students at UW Bothell, and anyone whose day just took a wrong turn.",
    neighborhoods: [
      "Downtown Bothell (Main Street)",
      "Canyon Park",
      "Country Village area",
      "Beardslee Crossing",
      "Bothell East",
      "Fitzgerald / 35th Ave",
      "Norway Hill",
      "UW Bothell campus corridor",
    ],
    highways: ["I-405", "SR-522", "Bothell-Everett Hwy (SR-527)", "228th St SE", "NE 195th St"],
    landmarks: [
      "University of Washington Bothell",
      "Cascadia College",
      "Bothell Landing Park",
      "Country Village",
      "Canyon Park Business Center",
      "McMenamins Anderson School",
    ],
    localAngle: "Bothell calls cover a genuinely wide range — freeway shoulder recoveries on I-405 near the SR-522 interchange, jump starts in Canyon Park office parks after long workdays, tire changes on the Bothell-Everett Highway, and late-night lockouts around UW Bothell student housing. Since we're a service-area business dispatched from Kirkland, our trucks are typically already north-bound on I-405 or nearby on SR-522 when your call comes in.",
    faqs: [
      { q: "How fast can a tow truck reach Bothell from Kirkland?", a: "Bothell is a short northbound run from our Kirkland dispatch — most of the time our closest truck is already on I-405 or SR-522 when you call. We give an honest ETA on the phone before we dispatch." },
      { q: "Do you handle I-405 breakdowns near Bothell?", a: "Yes. The I-405 / SR-522 interchange and shoulder calls between Bothell and Canyon Park are one of our most common jobs. We're equipped for freeway recoveries." },
      { q: "Can you help students at UW Bothell?", a: "Absolutely — jump starts, lockouts, flat tires, and short tows to a shop or apartment are all common calls from around the UW Bothell / Cascadia campus." },
      { q: "Do you tow to Bothell from a shop in Kirkland or Redmond?", a: "Yes. Dealer transfers and after-service pickups from Kirkland and Redmond shops to Bothell homes are scheduled routinely — call for a flat quote." },
      { q: "What if I'm stuck at Canyon Park after hours?", a: "Canyon Park is well within our 24/7 dispatch zone. Nights, weekends and holidays — the phone is always answered by a real person." },
    ],
  },

  woodinville: {
    slug: "woodinville",
    path: "/tow-truck-woodinville",
    name: "Woodinville",
    fullName: "Woodinville, WA",
    metaTitle: "24/7 Tow Truck in Woodinville, WA | BM Towing & Recovery",
    metaDesc: "Woodinville tow truck & roadside dispatch — flatbed, jump start, lockout, tire change. Winery tourist district & Hollywood Hill covered. Call BM Towing (425) 647-9585.",
    h1: "Woodinville Tow Truck & Roadside Assistance",
    hero: "Wine-country visits, hillside driveways, weekend traffic — Woodinville has its own rhythm. We dispatch a truck to match it.",
    intro: "Woodinville is a friendly, mixed-use city — a downtown core, a busy winery tourist district, and residential hills that ripple out to Hollywood Hill and Cottage Lake. That mix means our Woodinville calls range from champagne-tasting-day flat tires in the Warehouse District to weekday jump starts in downtown parking lots. As a home-based, mobile towing operation dispatching from Kirkland, we skip the queue at brick-and-mortar tow yards — one call puts a driver on SR-522 headed your way, day or night.",
    neighborhoods: [
      "Downtown Woodinville",
      "Warehouse District (Winery Row)",
      "Hollywood Hill",
      "Cottage Lake area",
      "Wellington",
      "Bear Creek",
      "Woodmoor",
    ],
    highways: ["SR-522", "SR-202 (Woodinville-Redmond Rd)", "NE 175th St", "SR-9 access", "132nd Ave NE"],
    landmarks: [
      "Ste. Michelle Winery / Warehouse District",
      "Chateau Ste. Michelle",
      "Molbak's Garden + Home area",
      "Woodinville Whiskey Co.",
      "Cottage Lake Park",
      "Willows Lodge",
    ],
    localAngle: "The winery/tourist crowd on weekends can turn a flat tire or dead battery into a real problem — visitors are unfamiliar with the area, restaurants close, and shoulder space on SR-202 is thin. We take the phone call, quote the job, and get a friendly, professional driver on scene fast so guests can get back to their afternoon. Weekday calls tilt more toward hillside residential help around Hollywood Hill and Cottage Lake — where narrow driveways call for a careful flatbed operator, not a rushed hook.",
    faqs: [
      { q: "Do you serve Woodinville's Warehouse Winery District on weekends?", a: "Yes. Saturdays and Sundays are some of our busiest Woodinville days — visiting drivers with dead batteries, flat tires, or lockouts. We treat winery-district calls as high priority because visitors are far from home." },
      { q: "How long does a Woodinville tow take to arrive?", a: "Depending on traffic on SR-522 and 405, most Woodinville calls are within a comfortable window. We always give an honest ETA before we dispatch — no vague promises." },
      { q: "Can you handle a car stuck on Hollywood Hill in bad weather?", a: "Yes. Hillside recoveries on Hollywood Hill or Cottage Lake — especially in wet/icy conditions — are handled with our flatbed and winch equipment for a safe, no-drama recovery." },
      { q: "Do you tow to and from Woodinville dealerships or wineries?", a: "Yes — dealer transfers, private buyer deliveries, and even the occasional weekend guest-vehicle move from a winery back to Seattle or Bellevue are routine calls. Quoted on the phone before we roll." },
      { q: "Are you the closest 24/7 tow truck to Woodinville?", a: "We're a mobile service dispatched from Kirkland, so we're often already on SR-522 or in nearby Bothell/Redmond when your call comes in. Availability beats the map pin on a shop that's closed at night." },
    ],
  },
};

export const CITY_SLUGS = Object.keys(CITIES);
export function getCity(slug) {
  return CITIES[slug] || null;
}

// Slug aliases for legacy internal links pointing at old cities.
export const CITY_SLUG_ALIASES = {
  kenmore: "kirkland",
};
